(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sr-bundle-offers"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('sr-bundle-offers')) return;

    var OB = String.fromCharCode(123);
    var CB = String.fromCharCode(125);
    var DEFAULT_MONEY = '$' + OB + OB + 'amount' + CB + CB;
    var instances = [];

    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = parseInt(cents.replace(/[^0-9-]/g, ''), 10);
      if (isNaN(cents)) cents = 0;
      format = format || DEFAULT_MONEY;
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      function withDelimiters(number, precision, thousands, decimal) {
        var fixed = (number / 100).toFixed(precision);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var match = format.match(placeholder);
      var token = match ? match[1] : 'amount';
      var value;
      switch (token) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        default: value = withDelimiters(cents, 2, ',', '.');
      }
      return format.replace(placeholder, value);
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
      });
    }

    function sizeKey(title) {
      return String(title || '').toLowerCase().replace(/\s+/g, '');
    }

    function findVariant(product, variantId) {
      var variants = (product && product.variants) || [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) return variants[i];
      }
      return null;
    }

    function pickVariant(product, preferredTitle) {
      var variants = (product && product.variants) || [];
      var wanted = sizeKey(preferredTitle);
      var i;
      for (i = 0; i < variants.length; i++) {
        if (variants[i].available && sizeKey(variants[i].title) === wanted) return variants[i];
      }
      for (i = 0; i < variants.length; i++) {
        if (variants[i].available) return variants[i];
      }
      return variants[0] || null;
    }

    function fromStorefront(product) {
      var image = product.images && product.images[0] ? product.images[0].src : '';
      if (image) image += (image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
      return {
        id: product.id,
        title: String(product.title || '').replace(/^decant\s+/i, ''),
        image: image,
        tags: tags.map(function (tag) { return String(tag).trim().toLowerCase(); }),
        variants: (product.variants || []).map(function (variant) {
          return { id: variant.id, title: variant.title, price: Math.round(parseFloat(variant.price) * 100) || 0, available: !!variant.available };
        })
      };
    }

    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM' || !form.closest) return;
      var productForm = form.closest('product-form-component');
      if (!productForm) return;
      for (var i = 0; i < instances.length; i++) {
        var instance = instances[i];
        if (instance.isConnected && instance.tier > 1 && instance.productForm() === productForm) {
          event.preventDefault();
          event.stopImmediatePropagation();
          instance.addBundle(form);
          return;
        }
      }
    }, true);

    class SrBundleOffers extends HTMLElement {
      connectedCallback() {
        if (instances.indexOf(this) === -1) instances.push(this);
        var self = this;

        if (!this.initialized) {
          this.initialized = true;
          this.moneyFormat = (this.dataset.moneyFormat || DEFAULT_MONEY).replace(/<[^>]*>/g, '');
          this.noDecimals = /no_decimals/.test(this.moneyFormat);
          this.percents = { 2: Number(this.dataset.tier2Percent) || 0, 3: Number(this.dataset.tier3Percent) || 0 };
          this.labels = {
            save: this.dataset.saveLabel || 'Ahorra',
            slot: this.dataset.slotLabel || 'decant',
            change: this.dataset.changeLabel || 'Elige otro',
            choose: this.dataset.chooseLabel || 'Elegir',
            add: this.dataset.addLabel || 'Agregar',
            from: this.dataset.fromLabel || 'Desde',
            format: this.dataset.formatLabel || 'Formato',
            error: this.dataset.errorLabel || 'No se pudo agregar al carrito.',
            loading: this.dataset.loadingLabel || 'Cargando…',
            empty: this.dataset.emptyLabel || 'No hay decants disponibles.'
          };
          this.main = this.readJson('[data-sr-bundle-main]', { variants: [] });
          this.tier = 1;
          this.busy = false;
          this.products = null;
          this.loading = false;
          this.modalSlot = 0;

          var suggestions = this.readJson('[data-sr-bundle-suggestions]', []);
          var mainVariant = this.currentMain();
          this.extras = [0, 1].map(function (index) {
            var suggestion = suggestions[index];
            if (!suggestion) return null;
            var variant = pickVariant(suggestion, mainVariant && mainVariant.title);
            return variant ? { product: suggestion, variantId: variant.id, touched: false } : null;
          });

          this.addEventListener('change', function (event) {
            var radio = event.target.closest && event.target.closest('[data-sr-bundle-radio]');
            if (radio) self.setTier(Number(radio.value));
          });
          this.addEventListener('click', function (event) {
            self.onClick(event);
          });
          this.addEventListener('input', function (event) {
            if (event.target.matches && event.target.matches('[data-sr-bundle-search]')) self.filterList(event.target.value);
          });
          this.addEventListener('close', function (event) {
            if (event.target.matches && event.target.matches('[data-sr-bundle-modal]')) {
              document.documentElement.classList.remove('sr-bundle-lock');
            }
          }, true);

          this.onVariantChange = function (event) {
            if (!event.target.closest || !event.target.closest('variant-picker')) return;
            window.setTimeout(function () { self.syncExtras(); self.render(); }, 60);
            window.setTimeout(function () { self.syncExtras(); self.render(); }, 800);
          };
        }

        document.addEventListener('change', this.onVariantChange);
        this.render();
      }

      disconnectedCallback() {
        var index = instances.indexOf(this);
        if (index > -1) instances.splice(index, 1);
        document.removeEventListener('change', this.onVariantChange);
      }

      readJson(selector, fallback) {
        var element = this.querySelector(selector);
        if (!element) return fallback;
        try {
          return JSON.parse(element.textContent);
        } catch (error) {
          return fallback;
        }
      }

      scope() {
        return this.closest('.shopify-section') || document;
      }

      productForm() {
        var scope = this.scope();
        var forms = scope.querySelectorAll('product-form-component');
        for (var i = 0; i < forms.length; i++) {
          if (forms[i].dataset.productId === this.dataset.productId) return forms[i];
        }
        return null;
      }

      currentMain() {
        var variants = (this.main && this.main.variants) || [];
        var variantId = null;
        var checked = this.scope().querySelector('variant-picker input:checked[data-variant-id]');
        if (checked) variantId = checked.dataset.variantId;
        if (!variantId) {
          var form = this.productForm();
          var input = form && form.querySelector('input[name="id"]');
          if (input) variantId = input.value;
        }
        var match = findVariant(this.main, variantId);
        if (match) return match;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available) return variants[i];
        }
        return variants[0] || null;
      }

      roundAmount(cents) {
        return this.noDecimals ? Math.round(cents / 100) * 100 : Math.round(cents);
      }

      tierTotals(tier) {
        var main = this.currentMain();
        if (!main) return null;
        var units = [main.price];
        var complete = true;
        for (var i = 0; i < tier - 1; i++) {
          var extra = this.extras[i];
          var variant = extra && findVariant(extra.product, extra.variantId);
          if (variant) {
            units.push(variant.price);
          } else {
            complete = false;
          }
        }
        var original = units.reduce(function (sum, value) { return sum + value; }, 0);
        var discount = 0;
        var percent = this.percents[tier] || 0;
        if (tier > 1 && complete && percent > 0) {
          var sorted = units.slice().sort(function (a, b) { return a - b; });
          for (var j = 0; j < tier - 1; j++) {
            discount += this.roundAmount((sorted[j] * percent) / 100);
          }
        }
        var compare = original;
        if (tier === 1 && main.compare > main.price) compare = main.compare;
        return { total: original - discount, compare: compare, discount: discount };
      }

      slotsHtml(count) {
        var html = '';
        for (var i = 0; i < count; i++) {
          var extra = this.extras[i];
          var label = (i + 2) + 'º ' + this.labels.slot;
          if (!extra) {
            html += '<div class="sr-bundle__slot sr-bundle__slot--empty">' +
              '<div class="sr-bundle__slot-body"><p class="sr-bundle__slot-label">' + escapeHtml(label) + '</p></div>' +
              '<button type="button" class="sr-bundle__change" data-sr-bundle-change="' + i + '">' + escapeHtml(this.labels.choose) + '</button>' +
              '</div>';
            continue;
          }
          var product = extra.product;
          var formats = (product.variants || []).map(function (variant) {
            var pressed = String(variant.id) === String(extra.variantId);
            return '<button type="button" class="sr-bundle__format" data-sr-bundle-format="' + i + '" data-variant-id="' + escapeHtml(variant.id) + '" aria-pressed="' + (pressed ? 'true' : 'false') + '"' + (variant.available ? '' : ' disabled') + '>' + escapeHtml(variant.title) + '</button>';
          }).join('');
          var image = product.image
            ? '<img class="sr-bundle__slot-img" src="' + escapeHtml(product.image) + '" alt="" width="52" height="52" loading="lazy">'
            : '<span class="sr-bundle__slot-img" aria-hidden="true"></span>';
          html += '<div class="sr-bundle__slot">' + image +
            '<div class="sr-bundle__slot-body">' +
            '<div class="sr-bundle__slot-head"><div><p class="sr-bundle__slot-label">' + escapeHtml(label) + '</p>' +
            '<p class="sr-bundle__slot-title">' + escapeHtml(product.title) + '</p></div>' +
            '<button type="button" class="sr-bundle__change" data-sr-bundle-change="' + i + '">' + escapeHtml(this.labels.change) + '</button></div>' +
            '<div class="sr-bundle__formats" role="group" aria-label="' + escapeHtml(this.labels.format) + '">' + formats + '</div>' +
            '</div></div>';
        }
        return html;
      }

      render() {
        var self = this;
        var active = document.activeElement;
        var focusKey = null;
        if (active && this.contains(active)) {
          if (active.dataset.srBundleFormat !== undefined) focusKey = '[data-sr-bundle-format="' + active.dataset.srBundleFormat + '"][data-variant-id="' + active.dataset.variantId + '"]';
          else if (active.dataset.srBundleChange !== undefined) focusKey = '[data-sr-bundle-change="' + active.dataset.srBundleChange + '"]';
        }

        this.querySelectorAll('[data-sr-bundle-tier]').forEach(function (tierElement) {
          var tier = Number(tierElement.dataset.srBundleTier);
          var selected = tier === self.tier;
          tierElement.classList.toggle('is-selected', selected);

          var radio = tierElement.querySelector('[data-sr-bundle-radio]');
          if (radio) radio.checked = selected;

          var totals = self.tierTotals(tier);
          var priceElement = tierElement.querySelector('[data-sr-bundle-price]');
          var compareElement = tierElement.querySelector('[data-sr-bundle-compare]');
          var saveElement = tierElement.querySelector('[data-sr-bundle-save]');
          if (totals && priceElement) {
            priceElement.textContent = formatMoney(totals.total, self.moneyFormat);
            var showCompare = totals.compare > totals.total;
            compareElement.hidden = !showCompare;
            compareElement.textContent = showCompare ? formatMoney(totals.compare, self.moneyFormat) : '';
            saveElement.hidden = !(totals.discount > 0);
            saveElement.textContent = totals.discount > 0 ? self.labels.save + ' ' + formatMoney(totals.discount, self.moneyFormat) : '';
          }

          var slots = tierElement.querySelector('[data-sr-bundle-slots]');
          if (slots) {
            slots.hidden = !selected;
            slots.innerHTML = selected ? self.slotsHtml(tier - 1) : '';
          }
        });

        var form = this.productForm();
        var buyButtons = form && form.closest('.buy-buttons-block');
        if (buyButtons) buyButtons.classList.toggle('sr-bundle-multi', this.tier > 1);

        if (focusKey) {
          var again = this.querySelector(focusKey);
          if (again) again.focus({ preventScroll: true });
        }
      }

      syncExtras() {
        var main = this.currentMain();
        if (!main) return;
        this.extras.forEach(function (extra) {
          if (!extra || extra.touched) return;
          var variant = pickVariant(extra.product, main.title);
          if (variant) extra.variantId = variant.id;
        });
      }

      setTier(tier) {
        this.tier = tier;
        this.hideError();
        this.syncExtras();
        this.render();
      }

      onClick(event) {
        var target = event.target;
        if (!target.closest) return;

        var format = target.closest('[data-sr-bundle-format]');
        if (format) {
          if (format.disabled) return;
          var extra = this.extras[Number(format.dataset.srBundleFormat)];
          if (extra) {
            extra.variantId = format.dataset.variantId;
            extra.touched = true;
            this.render();
          }
          return;
        }

        var change = target.closest('[data-sr-bundle-change]');
        if (change) {
          this.openModal(Number(change.dataset.srBundleChange));
          return;
        }

        if (target.closest('[data-sr-bundle-close]')) {
          this.closeModal();
          return;
        }

        var pick = target.closest('[data-sr-bundle-pick]');
        if (pick) {
          this.choose(Number(pick.dataset.srBundlePick));
          return;
        }

        if (target.matches('[data-sr-bundle-modal]')) this.closeModal();
      }

      modal() {
        return this.querySelector('[data-sr-bundle-modal]');
      }

      openModal(slot) {
        var modal = this.modal();
        if (!modal) return;
        this.modalSlot = slot;
        var search = modal.querySelector('[data-sr-bundle-search]');
        if (search) search.value = '';
        if (!modal.open) {
          if (typeof modal.showModal === 'function') {
            modal.showModal();
          } else {
            modal.setAttribute('open', '');
          }
        }
        document.documentElement.classList.add('sr-bundle-lock');
        this.loadProducts();
      }

      closeModal() {
        var modal = this.modal();
        if (modal && modal.open) {
          if (typeof modal.close === 'function') {
            modal.close();
          } else {
            modal.removeAttribute('open');
          }
        }
        document.documentElement.classList.remove('sr-bundle-lock');
      }

      loadProducts() {
        var self = this;
        var status = this.querySelector('[data-sr-bundle-status]');
        if (this.products) {
          this.renderList();
          return;
        }
        if (this.loading) return;
        var base = (this.dataset.collectionUrl || '').replace(/\/$/, '');
        if (!base) {
          if (status) status.textContent = this.labels.empty;
          return;
        }
        this.loading = true;
        if (status) status.textContent = this.labels.loading;

        fetch(base + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error(String(response.status));
            return response.json();
          })
          .then(function (data) {
            var exclude = (self.dataset.excludeTag || '').trim().toLowerCase();
            var eligible = (self.dataset.eligibleTag || '').trim().toLowerCase();
            self.products = (data.products || []).map(fromStorefront).filter(function (product) {
              if (String(product.id) === String(self.dataset.productId)) return false;
              if (exclude && product.tags.indexOf(exclude) > -1) return false;
              if (eligible && product.tags.indexOf(eligible) === -1) return false;
              return product.variants.some(function (variant) { return variant.available; });
            });
            self.loading = false;
            self.renderList();
          })
          .catch(function () {
            self.loading = false;
            if (status) status.textContent = self.labels.error;
          });
      }

      renderList() {
        var self = this;
        var list = this.querySelector('[data-sr-bundle-list]');
        var status = this.querySelector('[data-sr-bundle-status]');
        if (!list) return;
        list.innerHTML = this.products.map(function (product, index) {
          var prices = product.variants.filter(function (variant) { return variant.available; }).map(function (variant) { return variant.price; });
          var lowest = prices.length ? Math.min.apply(null, prices) : 0;
          var image = product.image
            ? '<img class="sr-bundle__pick-img" src="' + escapeHtml(product.image) + '" alt="" width="64" height="64" loading="lazy">'
            : '<span class="sr-bundle__pick-img" aria-hidden="true"></span>';
          return '<li class="sr-bundle__pick" data-title="' + escapeHtml(product.title.toLowerCase()) + '">' + image +
            '<div><p class="sr-bundle__pick-title">' + escapeHtml(product.title) + '</p>' +
            '<p class="sr-bundle__pick-price">' + escapeHtml(self.labels.from) + ' ' + formatMoney(lowest, self.moneyFormat) + '</p></div>' +
            '<button type="button" class="sr-bundle__pick-add" data-sr-bundle-pick="' + index + '">' + escapeHtml(self.labels.add) + '</button>' +
            '</li>';
        }).join('');
        if (status) status.textContent = this.products.length ? '' : this.labels.empty;
      }

      filterList(query) {
        var term = String(query || '').trim().toLowerCase();
        this.querySelectorAll('[data-sr-bundle-list] .sr-bundle__pick').forEach(function (item) {
          item.hidden = term !== '' && item.dataset.title.indexOf(term) === -1;
        });
      }

      choose(index) {
        var product = this.products && this.products[index];
        if (!product) return;
        var main = this.currentMain();
        var variant = pickVariant(product, main && main.title);
        if (!variant) return;
        this.extras[this.modalSlot] = { product: product, variantId: variant.id };
        this.closeModal();
        this.render();
        var change = this.querySelector('[data-sr-bundle-change="' + this.modalSlot + '"]');
        if (change) change.focus({ preventScroll: true });
      }

      showError(message) {
        var element = this.querySelector('[data-sr-bundle-error]');
        if (!element) return;
        element.textContent = message;
        element.hidden = false;
      }

      hideError() {
        var element = this.querySelector('[data-sr-bundle-error]');
        if (element) element.hidden = true;
      }

      bundleItems(form) {
        var needed = this.tier - 1;
        for (var i = 0; i < needed; i++) {
          if (!this.extras[i] || !this.extras[i].variantId) {
            this.openModal(i);
            return null;
          }
        }

        var main = this.currentMain();
        var input = form.querySelector('input[name="id"]');
        var mainId = input && input.value ? input.value : main && main.id;
        var items = [{ id: Number(mainId), quantity: 1 }];
        for (var j = 0; j < needed; j++) {
          items.push({ id: Number(this.extras[j].variantId), quantity: 1 });
        }
        return items;
      }

      addBundle(form) {
        if (this.busy) return;
        var items = this.bundleItems(form);
        if (!items) return;

        var self = this;
        var button = form.querySelector('[ref="addToCartButton"]');
        this.busy = true;
        this.hideError();
        if (button) button.setAttribute('aria-busy', 'true');

        var request = window.SRCart
          ? window.SRCart.add(items, { source: this, sourceId: 'sr-bundle-offers' })
          : fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items })
            }).then(function (response) {
              return response.json().then(function (data) {
                if (!response.ok || data.status) throw data;
                window.location.href = '/cart';
                return data;
              });
            });

        request
          .then(function () {
            if (window.SRCart) window.SRCart.openDrawer();
          })
          .catch(function (error) {
            self.showError((error && (error.description || error.message)) || self.labels.error);
          })
          .then(function () {
            self.busy = false;
            if (button) button.removeAttribute('aria-busy');
          });
      }
    }

    window.SRBundleOffers = {
      itemsFor: function (form) {
        var productForm = form && form.closest ? form.closest('product-form-component') : null;
        if (!productForm) return false;
        for (var i = 0; i < instances.length; i++) {
          var instance = instances[i];
          if (instance.isConnected && instance.tier > 1 && instance.productForm() === productForm) {
            return instance.bundleItems(form);
          }
        }
        return false;
      }
    };

    window.customElements.define('sr-bundle-offers', SrBundleOffers);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sr-buy-now"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('sr-buy-now')) return;

    class SrBuyNow extends HTMLElement {
      constructor() {
        super();
        this.busy = false;
        this.originalLabel = '';
        this.handleClick = this.handleClick.bind(this);
        this.handlePageShow = this.handlePageShow.bind(this);
        this.sync = this.sync.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        window.addEventListener('pageshow', this.handlePageShow);
        var scope = this.closest('.shopify-section');
        if (scope) {
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(scope, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['disabled'],
          });
        }
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('pageshow', this.handlePageShow);
        if (this.observer) this.observer.disconnect();
      }

      get button() {
        return this.querySelector('[data-sr-buy-now]');
      }

      get form() {
        var id = this.dataset.formId;
        var scope = this.closest('.shopify-section');
        var local = scope ? scope.querySelector('[id="' + id + '"]') : null;
        return local || document.getElementById(id);
      }

      get addButton() {
        var form = this.form;
        return form ? form.querySelector('button[name="add"]') : null;
      }

      sync() {
        if (this.busy) return;
        var button = this.button;
        var add = this.addButton;
        if (!button || !add) return;
        if (button.disabled !== add.disabled) button.disabled = add.disabled;
      }

      handlePageShow(event) {
        if (event.persisted) this.reset();
      }

      reset() {
        this.busy = false;
        var button = this.button;
        if (!button) return;
        button.removeAttribute('aria-busy');
        button.disabled = false;
        var label = button.querySelector('[data-sr-buy-now-label]');
        if (label && this.originalLabel) label.textContent = this.originalLabel;
        this.sync();
      }

      showError(message) {
        var error = this.querySelector('[data-sr-buy-now-error]');
        if (!error) return;
        error.textContent = message || '';
        error.hidden = !message;
      }

      request(form) {
        var bundle = false;
        if (window.SRBundleOffers && typeof window.SRBundleOffers.itemsFor === 'function') {
          bundle = window.SRBundleOffers.itemsFor(form);
        }
        if (bundle === null) return null;
        if (Array.isArray(bundle)) {
          return {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: bundle }),
          };
        }
        return {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        };
      }

      handleClick(event) {
        var button = event.target.closest('[data-sr-buy-now]');
        if (!button || button.disabled || this.busy) return;

        var form = this.form;
        var add = this.addButton;
        if (!form || (add && add.disabled)) return;
        if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

        var options = this.request(form);
        if (!options) return;

        var self = this;
        var label = button.querySelector('[data-sr-buy-now-label]');
        this.busy = true;
        this.originalLabel = label ? label.textContent : '';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (label && this.dataset.loadingText) label.textContent = this.dataset.loadingText;
        this.showError('');

        fetch(this.dataset.addUrl, options)
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok || data.status) throw new Error(data.description || data.message || '');
              return data;
            });
          })
          .then(function () {
            var rewards = document.querySelector('srprofumo-cart-rewards');
            if (rewards && typeof rewards.syncGifts === 'function') {
              return rewards.syncGifts().catch(function () {});
            }
          })
          .then(function () {
            window.location.assign(self.dataset.checkoutUrl);
          })
          .catch(function (error) {
            self.reset();
            self.showError((error && error.message) || self.dataset.errorText);
          });
      }
    }

    customElements.define('sr-buy-now', SrBuyNow);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sr-routine-builder"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.customElements.get('sr-routine-builder')) return;

  if (window.console && console.info) console.info('[sr-routine-builder] versión: compact-ui (v3)');

  var LAST_SUBMIT = 0;
  var SUBMIT_WINDOW = 1200;

  var OB = String.fromCharCode(123);
  var CB = String.fromCharCode(125);
  var DEFAULT_MONEY = '$' + OB + OB + 'amount' + CB + CB;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents.replace(/[^0-9-]/g, ''), 10);
    if (isNaN(cents)) cents = 0;
    format = format || DEFAULT_MONEY;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = (thousands == null) ? ',' : thousands;
      decimal = (decimal == null) ? '.' : decimal;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? (decimal + parts[1]) : '';
      return dollars + rest;
    }
    var match = format.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function discountedCents(cents, discount) {
    return cents - Math.floor((cents * discount) / 100);
  }

  class SrRoutineBuilder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.moneyFormat = (this.dataset.moneyFormat || DEFAULT_MONEY).replace(/<[^>]*>/g, '');
      this.discount = parseInt(this.dataset.discount, 10) || 0;
      this.maxExtras = parseInt(this.dataset.maxExtras, 10) || 3;
      this.discountCode = (this.dataset.discountCode || '').trim();
      this.blockId = this.dataset.blockId || '';
      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.busy = false;

      this.extrasEl = this.querySelector('[data-sr-rb-extras]');
      this.countEl = this.querySelector('[data-sr-rb-count]');
      this.saveEl = this.querySelector('[data-sr-rb-save]');
      this.totalEl = this.querySelector('[data-sr-rb-total]');
      this.totalWasEl = this.querySelector('[data-sr-rb-total-was]');
      this.ctaEl = this.querySelector('[data-sr-rb-add]');
      this.ctaLabelEl = this.querySelector('[data-sr-rb-cta-label]');
      this.spinnerEl = this.querySelector('.sr-rb__spinner');
      this.liveEl = this.querySelector('[data-sr-rb-live]');

      this.labelItems = this.dataset.labelItems || 'items seleccionados';
      this.labelSave = this.dataset.labelSave || 'Ahorras';
      this.labelButton = this.dataset.labelButton || 'LLEVAR · ITEMS AL CARRO';

      var self = this;
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-sr-rb-add]')) self.onAdd();
      });

      this.recalc();
    }

    onChange() { this.recalc(); }

    rowState(row) {
      var check = row.querySelector('[data-sr-rb-check]');
      var variantEl = row.querySelector('[data-sr-rb-variant]');
      if (!variantEl) return null;
      var isExtra = row.dataset.extra === 'true';
      var cents, variantId;
      if (variantEl.tagName === 'SELECT') {
        var opt = variantEl.options[variantEl.selectedIndex];
        cents = parseInt(opt ? opt.dataset.price : 0, 10) || 0;
        variantId = variantEl.value;
      } else {
        cents = parseInt(variantEl.dataset.price, 10) || 0;
        variantId = variantEl.value;
      }
      var finalCents = isExtra ? discountedCents(cents, this.discount) : cents;
      return {
        row: row,
        checked: check && check.checked && !check.disabled,
        isExtra: isExtra,
        variantId: variantId,
        original: cents,
        final: finalCents
      };
    }

    updateRowPrices(state) {
      var wasEl = state.row.querySelector('[data-sr-rb-was]');
      var nowEl = state.row.querySelector('[data-sr-rb-now]');
      if (nowEl) nowEl.textContent = formatMoney(state.final, this.moneyFormat);
      if (wasEl) wasEl.textContent = formatMoney(state.original, this.moneyFormat);
    }

    recalc() {
      var rows = this.querySelectorAll('[data-sr-rb-row]');
      var count = 0, sumOriginal = 0, sumFinal = 0;
      var self = this;
      rows.forEach(function (row) {
        var st = self.rowState(row);
        if (!st) return;
        self.updateRowPrices(st);
        if (st.checked) {
          count++;
          sumOriginal += st.original;
          sumFinal += st.final;
        }
      });
      var saved = sumOriginal - sumFinal;

      this.countEl.textContent = count + ' ' + this.labelItems;
      this.totalEl.textContent = count ? formatMoney(sumFinal, this.moneyFormat) : '—';

      if (saved > 0) {
        this.totalWasEl.hidden = false;
        this.totalWasEl.textContent = formatMoney(sumOriginal, this.moneyFormat);
        this.saveEl.hidden = false;
        this.saveEl.textContent = this.labelSave + ' ' + formatMoney(saved, this.moneyFormat);
      } else {
        this.totalWasEl.hidden = true;
        this.saveEl.hidden = true;
      }

      this.ctaEl.disabled = (count === 0) || this.busy;
      this.ctaLabelEl.textContent = this.labelButton.replace('·', String(count));
    }

    collectItems() {
      var items = [];
      var self = this;
      this.querySelectorAll('[data-sr-rb-row]').forEach(function (row) {
        var st = self.rowState(row);
        if (st && st.checked && st.variantId) {
          items.push({ id: Number(st.variantId), quantity: 1 });
        }
      });
      return items;
    }

    status(msg) { if (this.liveEl) this.liveEl.textContent = msg || ''; }

    applyDiscount() {
      if (!this.discountCode) return;
      try {
        fetch('/discount/' + encodeURIComponent(this.discountCode), { method: 'GET', credentials: 'same-origin' })
          .catch(function () {});
      } catch (e) {}
    }

    onAdd() {
      var now = Date.now();
      if (this.busy || (now - LAST_SUBMIT) < SUBMIT_WINDOW) return;
      var items = this.collectItems();
      var self = this;
      if (!items.length) { this.status('Selecciona al menos un producto disponible.'); return; }
      LAST_SUBMIT = now;
      this.setBusy(true);

      this.cartAddItems(items)
        .then(function (result) {
          self.setBusy(false);
          if (result.added > 0) {
            self.applyDiscount();
            self.refreshCart();
            self.status('✓ Carrito: ' + (result.cart.item_count || result.added) + ' productos');
          } else {
            self.status(result.error || 'No se pudo agregar al carrito. Revisa el stock e intenta de nuevo.');
          }
        })
        .catch(function (err) {
          self.setBusy(false);
          var msg = (err && err.message) ? err.message : String(err);
          self.status('No se pudo agregar (' + msg + ').');
          if (window.console && console.error) console.error('[sr-routine-builder] error al agregar:', err);
        });
    }

    cartAddItems(items) {
      var self = this;
      var added = 0;
      var error = '';
      var chain = Promise.resolve();
      items.forEach(function (it) {
        chain = chain.then(function () {
          var fd = new FormData();
          fd.append('id', it.id);
          fd.append('quantity', it.quantity);
          return fetch(self.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          }).then(function (r) {
            return r.text().then(function (txt) {
              var b = {};
              try { b = JSON.parse(txt); } catch (e) {}
              if (r.ok && !b.status) {
                added++;
              } else {
                error = b.description || b.message || ('Error ' + r.status);
                if (window.console && console.warn) console.warn('[sr-routine-builder] no se agregó la variante ' + it.id + ':', b);
              }
            });
          });
        });
      });
      return chain.then(function () {
        return fetch('/cart.js?t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { cart: cart, added: added, error: error }; })
          .catch(function () { return { cart: { item_count: added }, added: added, error: error }; });
      });
    }

    refreshCart() {
      if (!window.SRCart) return;
      window.SRCart
        .refresh({ action: 'add', source: this, sourceId: 'sr-routine-builder' })
        .catch(function () {})
        .then(function () { window.SRCart.openDrawer(); });
    }

    setBusy(state) {
      this.busy = state;
      if (this.ctaEl) {
        this.ctaEl.setAttribute('aria-busy', state ? 'true' : 'false');
        this.ctaEl.disabled = state || (this.collectItems().length === 0);
      }
      if (this.spinnerEl) this.spinnerEl.hidden = !state;
    }
  }

  window.customElements.define('sr-routine-builder', SrRoutineBuilder);
})();
  } catch(e) { console.error(e); }
})();

})();
